<template>
    <div class="row">
        <div class="col-xl-12">
            <div id="panel-1" class="panel">
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="d-flex justify-content-between">
                            <div class="cursor-pointer" @click="dialogFilterVisible = true">
                                <i class="fa fa-filter mt-1"></i>
                                <span class="fw-bolder ml-1">Chỉnh sửa bộ lọc</span>
                            </div>
                            <el-dropdown @command="handleDropdownCommand">
                                <el-button type="primary" size="mini">
                                    Hành động<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="[3, 4, 5, 6, 7].includes(keyAccount)"
                                        command="import_amount">Import số tiền nhập</el-dropdown-item>
                                    <el-dropdown-item v-if="[3, 4, 5, 6, 7].includes(keyAccount)"
                                        command="import_customer">Import khách hàng</el-dropdown-item>
                                    <el-dropdown-item command="export">Export danh sách khách hàng</el-dropdown-item>
                                    <el-dropdown-item command="note">Note khách hàng</el-dropdown-item>
                                    <el-dropdown-item v-if="[3, 4, 5, 6, 7].includes(keyAccount)"
                                        command="searchInfoCustomer">Tra cứu thông tin khách hàng</el-dropdown-item>
                                    <el-dropdown-item command="notificationSupportEndCourse">Nhắc nhở chăm sóc cuối
                                        khóa</el-dropdown-item>
                                    <el-dropdown-item command="chart">Thống kê</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <!-- start filter -->
                        <el-row :gutter="10" id="edutalk-customer-list">
                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-show="shouldShow('name')">
                                <el-input @input="debouncedQueryServer" type="text" size="medium" v-model="form.name"
                                    class="mt-3" placeholder="Tên, SĐT khách hàng" clearable autocomplete="false" />
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="3" v-show="shouldShow('level')">
                                <el-select @change="querySever" v-model="form.level" clearable class="w-100 mt-3"
                                    placeholder="Chọn level">
                                    <el-option v-for="item in optionLevel" :key="item.id" :label="item.value"
                                        :value="item.id">
                                        <span style="float: left">{{ item.value }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="3" v-show="shouldShow('ngay_hen')">
                                <el-date-picker v-model="form.dateRange" class="w-100 mt-3" type="daterange"
                                    value-format="yyyy-MM-dd" start-placeholder="Ngày hẹn " @change="querySever" />
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="3"
                                v-show="shouldShow('dieu_kien_tai_chinh')">
                                <el-select v-model="form.dieu_kien_tai_chinh" @change="querySever" clearable
                                    class="w-100 mt-3" placeholder="Tài chính">
                                    <el-option v-for="item in optionFinance" :key="item.id" :label="item.value"
                                        :value="item.id" />
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="3" v-show="shouldShow('trang_thai_tu_van')">
                                <el-select v-model="form.trang_thai_tu_van" @change="querySever" clearable
                                    class="w-100 mt-3" placeholder="Trạng thái tư vấn">
                                    <el-option v-for="item in optionTypeAdvise" :key="item.id" :label="item.value"
                                        :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="3" v-show="shouldShow('nguon')">
                                <el-select v-model="form.nguon" @change="querySever" clearable class="w-100 mt-3"
                                    placeholder="Kênh khách hàng">
                                    <el-option v-for="item in optionSource" :key="item.id" :label="item.value"
                                        :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="3"
                                v-show="shouldShow('branch_id') && isGDKV">
                                <el-select v-model="form.branch_id"
                                    @change="() => { handleChangeBranch(); querySever(); }" clearable filterable
                                    class="w-100 mt-3" placeholder="Chọn văn phòng để xem">
                                    <el-option v-for="item in branches" :key="item.id" :label="item.name"
                                        :value="item.id" />
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="3" v-show="shouldShow('sale')">
                                <tree-select class="w-100 mt-3 tree-customer" v-model="form.sale"
                                    placeholder="Chọn nhân sự muốn xem..." :options="options" :normalizer="normalizer"
                                    :show-count="true" search-nested @input="() => { chooseSale(); querySever(); }">
                                    <label slot="option-label"
                                        slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                        :class="labelClassName">
                                        <img :src="getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                                        <span>{{ node.label }}</span>
                                        <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                    </label>
                                </tree-select>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="3" v-show="shouldShow('view_as')">
                                <el-select v-model="form.view_as" @change="changeWatchAs();" clearable class="w-100 mt-3"
                                    placeholder="Chọn tư cách để xem">
                                    <el-option v-for="item in watchAs" :key="item.id" :label="item.value"
                                        :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="3" v-show="shouldShow('center')">
                                <el-select v-model="form.center_id" @change="querySever" filterable clearable
                                    class="w-100 mt-3" placeholder="Chọn trung tâm">
                                    <el-option v-for="item in centers" :key="item.id" :label="item.name"
                                        :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="3" v-show="shouldShow('hot_key')">
                                <el-select v-model="form.hot_key" @change="debounceQuerySever" filterable clearable
                                    multiple collapse-tags class="w-100 mt-3" placeholder="Chọn phím nóng">
                                    <el-option v-for="item in phimNongDeFine" :key="item.id" :label="item.value"
                                        :value="item.id">
                                        <span style="float: left">{{ item.value }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="3" v-show="shouldShow('ma_gioi_thieu')">
                                <el-input @input="debouncedQueryServer" type="text" size="medium"
                                    v-model="form.ma_gioi_thieu" class="mt-3" placeholder="Nhập mã/ người giới thiệu"
                                    clearable autocomplete="false" />
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :xs="24" :sm="24" :md="21" :lg="21" :xl="21">
                                <div class="mb-1 mt-3">
                                    <h4 class="text-sales">Doanh số nhập tháng {{ new Date().getMonth() + 1 }}:
                                        {{ dataSaleMonth?.import_amount | formatVND }} </h4>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="21" :lg="21" :xl="21">
                                <div class="mb-1 mt-1">
                                    <h4 class="text-sales">Doanh số dự kiến:
                                        {{ dataSaleMonth?.expected_amount | formatVND }} </h4>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="21" :lg="21" :xl="21">
                                <div class="mb-1 mt-1">
                                    <h4 class="text-sales">Doanh số thực tế: {{
                                        dataSaleMonth?.real_amount | formatVND
                                    }} </h4>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
                                <router-link class="btn btn-primary font-size-3 w-100 mt-3 mb-3"
                                    :to="{ name: 'customer-create' }">
                                    <i class="el-icon-plus"></i> Thêm khách hàng
                                </router-link>
                                <div @click="dialogFilterTableVisible = true" style="font-weight: 600; cursor: pointer"
                                    class="float-right mb-2">
                                    <i class="el-icon-setting"></i>
                                    <span class="ml-1">Hiển thị</span>
                                </div>
                            </el-col>
                        </el-row>
                        <!-- end filter -->
                        <div class="table-responsive-lg sticky-container">
                            <table class="table table-hover table-striped table-bordered table-customer">
                                <thead class="sticky-header">
                                    <tr>
                                        <th>#</th>
                                        <th v-for="col in visibleColumns" :key="col.key" :style="col.style">{{
                                            col.label
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(customer, key) in tableData">
                                        <tr v-if="!checkTranhChap(customer) || isCVHT" :key="customer.id">
                                            <td>{{ 25 * (paging.current_page - 1) + key + 1 }}</td>
                                            <td v-for="col in visibleColumns" :key="col.key">
                                                <template v-if="col.key === 'level'">
                                                    <div class="cell"
                                                        :style="{ 'background-color': customer.level_color }">
                                                        <p class="customer-level" v-html="customer.level"></p>
                                                    </div>
                                                </template>
                                                <template v-else-if="col.key === 'ngay_hen'">
                                                    <p v-if="customer.level_check !== '2E'">{{ customer.ngay_hen }}</p>
                                                    <p v-else>{{ customer.ngay_hen_dong_tien }}</p>
                                                </template>
                                                <template v-else-if="col.key === 'ngay_hen'">
                                                    <p v-if="customer.level_check !== '2E'">{{ customer.trung_tam_hen }}
                                                    </p>
                                                    <p v-else>{{ customer.center_contract }}</p>
                                                </template>
                                                <template v-else-if="col.key === 'trang_thai_tu_van'">
                                                    <p>{{ statusAdvice(customer.level_check, customer.is_advice) }}</p>
                                                </template>
                                                <template v-else-if="col.key === 'chi_nhanh_hen'">
                                                    <p v-if="customer.level_check !== '2E'">{{ customer.chi_nhanh_hen }}
                                                    </p>
                                                    <p v-else>{{ customer.branch_contract }}</p>
                                                </template>
                                                <template v-else-if="col.key === 'total_input_amount'">
                                                    <p>{{ customer.total_input_amount.toLocaleString('vi-VN') }} đ</p>
                                                </template>

                                            <template v-else-if="col.key === 'task'">
                                                <el-button
                                                    :type="taskMeta(customer.status_task).type"
                                                    size="mini"
                                                    @click="handleTask(customer)"
                                                >
                                                    {{ taskMeta(customer.status_task).label }}
                                                </el-button>
                                            </template>

                                                <template v-else-if="col.key === 'hot_key'">
                                                    <el-button v-if="hasHotKeys(customer)" type="primary" size="mini"
                                                        @click="handleHotkey(customer)">Chi tiết phím nóng</el-button>
                                                </template>

                                                <template v-else-if="col.key === 'ma_gioi_thieu'">
                                                    {{ customer.ma_gioi_thieu + ' - ' + customer.nguoi_gioi_thieu }}
                                                </template>

                                                <!-- <template v-else-if="col.key === 'khach_hang_cua'">
                                            <p>{{ customer.create_user }}</p>
                                            <p>{{ customer.parent_sale }}</p>
                                        </template> -->
                                                <template v-else-if="col.key === 'hanh_dong'">
                                                    <el-row class="action-table" style="text-align: center">
                                                        <el-tooltip
                                                            v-if="isPilotEntrance && getEntranceNeed(customer) === 0"
                                                            key="entrance-no-need"
                                                            content="Thông tin nhu cầu" placement="top">
                                                            <button
                                                                class="btn btn-warning btn-sm btn-icon waves-effect waves-themed mr-2"
                                                                @click="openEntranceNeedInfo(customer)">
                                                                <i class="fal fa-book"></i>
                                                            </button>
                                                        </el-tooltip>

                                                        <el-tooltip content="Ca test đầu vào" placement="top"
                                                            key="entrance-has-exam"
                                                            v-else-if="checkShowBtnDetailTest(customer?.list_exam)">
                                                            <button
                                                                class="btn btn-warning btn-sm btn-icon waves-effect waves-themed mr-2"
                                                                :disabled="loadingListExamId === customer.id"
                                                                @click="handleDetailEntrance(customer)">
                                                                <i v-if="loadingListExamId === customer.id" class="el-icon-loading"></i>
                                                                <i v-else class="fal fa-book"></i>
                                                            </button>
                                                        </el-tooltip>

                                                        <el-tooltip v-else
                                                            key="entrance-schedule"
                                                            :content="isPilotEntrance ? 'Đặt lịch test' : 'Đặt lịch test đầu vào'"
                                                            placement="top">
                                                            <a class="btn btn-success btn-sm btn-icon waves-effect waves-themed"
                                                                @click="selectCustomer(customer)">
                                                                <i class="el-icon-date"></i>
                                                            </a>
                                                        </el-tooltip>

                                                        <template>
                                                            <el-tooltip content="Xem thông tin khách hàng"
                                                                placement="top">
                                                                <router-link
                                                                    :to="{ name: 'customer-view', params: { id: customer.user_id }, query: { customer_id: customer?.id } }"
                                                                    class="btn btn-info btn-sm btn-icon waves-effect waves-themed">
                                                                    <i class="fa fa-eye"></i>
                                                                </router-link>
                                                            </el-tooltip>
                                                        </template>
                                                        <template
                                                            v-if="customer.level_int < 3 && customer.created_user === currentUser.id">
                                                            <el-tooltip
                                                                :content="customer.ngay_hen ? 'Đổi lịch tư vấn' : 'Đặt lịch tư vấn'"
                                                                placement="top">
                                                                <a @click="handleDatLichTuVan(customer)"
                                                                    :class="{ 'disabled': checkingConsultId === customer.id }"
                                                                    class="btn btn-info btn-sm btn-icon waves-effect waves-themed">
                                                                    <i v-if="checkingConsultId === customer.id" class="el-icon-loading"></i>
                                                                    <i v-else class="fal fa-calendar"></i>
                                                                </a>
                                                            </el-tooltip>
                                                        </template>
                                                        <el-tooltip
                                                            v-if="customer.level_int < 4 && customer.created_user === currentUser.id"
                                                            content="Sửa thông tin khách hàng" placement="top">
                                                            <router-link
                                                                :to="{ name: 'customer-edit', params: { id: customer.id } }"
                                                                class="btn btn-primary btn-sm btn-icon waves-effect waves-themed">
                                                                <i class="fal fa-edit"></i>
                                                            </router-link>
                                                        </el-tooltip>
                                                        <template>
                                                            <el-tooltip content='Nhập số tiền' class="mr-2"
                                                                placement="top">
                                                                <button
                                                                    style="background-color: #191589; border-color: #191589"
                                                                    @click="handleInputAmount(customer)"
                                                                    class="btn btn-sm btn-icon waves-effect waves-themed">
                                                                    <i style="background-color: white; color:#191589; padding: 3px 6px 4px 6px"
                                                                        class="fa fa-dollar-sign rounded-circle"></i>
                                                                </button>
                                                            </el-tooltip>
                                                        </template>

                                                        <template>
                                                            <el-tooltip
                                                                v-if="customer.level_int < 2 && customer.level !== '1E<br/>Lịch hẹn'"
                                                                content='Chuyển lịch hẹn' placement="top">
                                                                <button
                                                                    style="background-color: #ffc241; border-color: #ffc241"
                                                                    @click="switchLevel1E(customer.id)"
                                                                    class="btn btn-sm btn-icon waves-effect waves-themed border-0">
                                                                    <i style="color:rgb(139 109 109);"
                                                                        class="fa fa-fighter-jet"></i>
                                                                </button>
                                                            </el-tooltip>
                                                        </template>
                                                    </el-row>
                                                </template>
                                                <template v-else>
                                                    {{ customer[col.key] }}
                                                </template>
                                            </td>
                                        </tr>
                                        <tr v-else class="text-center" :key="`tranhchap-${customer.id}`"
                                            style="height: 80px; text-align: center;align-items: center; background-color: darkgray">
                                            <td> {{ 25 * (paging.current_page ? paging.current_page - 1 : 0) + (key + 1)
                                                }}</td>
                                            <td>{{ customer.name }}</td>
                                            <td colspan="16" style="vertical-align: middle; ">Data là khách hàng của
                                                sale khác</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <div class="edutalk-paging">
                            <div class="block" v-if="paging.total > 25">
                                <!--eslint-disable-->
                                <el-pagination background @current-change="handleCurrentChange"
                                    :current-page.sync="paging.current_page" :page-size="25" layout="prev, pager, next"
                                    :total="paging.total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="dialog.title" class="responsive" :visible.sync="dialogFormVisible">
            <el-row :gutter="10" class="pr-2 pl-2">
                <dat-lich-tu-van v-if="dialogFormVisible" @completed="completedUpdate" @close="closePopup"
                    :customer-id="customer_id" :customer-name="customer_name" :customer-phone="customer_phone"
                    :ngay-hen-old="ngay_hen" :displayTestInput="displayTestInput"></dat-lich-tu-van>
            </el-row>
        </el-dialog>
        <el-dialog title="Thông báo" class="responsive" :visible.sync="dialogTestScheduleCompleteVisible">
            <el-row :gutter="10" class="pr-2 pl-2">
                <test-schedule-complete v-if="dialogTestScheduleCompleteVisible"
                    @completed="closePopupTestSchedule"></test-schedule-complete>
            </el-row>
        </el-dialog>
        <!-- OLD: Đặt lịch test đầu vào (non-pilot) -->
        <el-dialog v-if="!isPilotEntrance" title="Đặt lịch test đầu vào" class="responsive" width="570px"
            :visible.sync="openScheduleTestInput"
            :destroy-on-close="true" @close="resetModal" :close-on-click-modal="false" :show-close="true">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form class="form appointment-form" @submit.prevent="handleSubmit(createScheduleTestInput)"
                    autocomplete="off">
                    <el-row :gutter="10" class="pr-2 pl-2">
                        <option-create-test-input :resetData="true" :is-create-customer="true" :confirm-only-general="true"
                            v-if="statusCreateTestInput === STATUS_CHOOSE_OPTION"
                            @cancel="openScheduleTestInput = false" @confirmOption="confirmOption" />
                        <reschedule-test-input v-if="statusCreateTestInput === STATUS_CREATE" :showTestInput="true"
                            :band-type="bandType" :show-learning-fields="true"
                            @infoTestInput="handleInfoTestInput" />
                        <LoadingCreateTestInput v-if="statusCreateTestInput === STATUS_PENDING"
                            :idTaskCreating="idTaskCreating" @statusCreateTestInput="handleStatusCreateTestInput"
                            :countTime="countTime" />
                        <succes-create-input v-if="statusCreateTestInput === STATUS_TO_DO"
                            @closeModal="openScheduleTestInput = false" @reloadPage=" querySever();"
                            :idCustomer="idCustomer" :successCreateData="successCreateData" />
                        <cancel-create-input v-if="statusCreateTestInput === STATUS_FAlURE"
                            @closeModal="openScheduleTestInput = false" />
                        <overload-create-test-input v-if="statusCreateTestInput === STATUS_OVER_LOADING"
                            @closeModal="openScheduleTestInput = false" />
                    </el-row>
                    <div class="form-row" v-if="statusCreateTestInput === STATUS_CREATE">
                        <div class="col-md-12 mb-3">
                            <button class="btn btn-primary float-right mt-3 ml-3" :disabled="isDisable">
                                Xác nhận
                            </button>
                            <button type="button" class="btn btn-secondary float-right mt-3 ml-3"
                                @click="statusCreateTestInput = STATUS_CHOOSE_OPTION">
                                Quay lại
                            </button>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </el-dialog>
        <!-- NEW: thí điểm -->
        <schedule-entrance-test-dialog
            v-if="isPilotEntrance"
            :visible.sync="scheduleEntranceTestDialogVisible"
            :close-on-confirm="false"
            :confirm-loading="entranceScheduleConfirmLoading"
            @confirm="confirmEntranceSchedule"
        />
        <entrance-list-dialog
            :visible.sync="entranceListDialogVisible"
            :list="selectedListExam"
            @view="handleViewEntranceExam"
        />
        <entrance-block-consult-dialog
            v-if="isPilotEntrance"
            :visible.sync="entranceBlockConsultDialogVisible"
            :loading="loadingListExamId !== null"
            @view="viewBlockingEntranceExams"
        />
        <entrance-need-info-dialog
            v-if="isPilotEntrance"
            :visible.sync="entranceNeedInfoDialogVisible"
            @register="handleEntranceNeedRegisterAgain"
        />
        <el-dialog
            v-if="isPilotEntrance && [STATUS_PENDING, STATUS_TO_DO, STATUS_FAlURE, STATUS_OVER_LOADING].includes(statusCreateTestInput)"
            title="Đặt lịch test đầu vào"
            class="responsive"
            width="570px"
            :visible.sync="openScheduleTestInput"
            :destroy-on-close="true"
            @close="resetModal"
            :close-on-click-modal="false"
            :show-close="true"
        >
            <el-row :gutter="10" class="pr-2 pl-2">
                <LoadingCreateTestInput v-if="statusCreateTestInput === STATUS_PENDING"
                    :idTaskCreating="idTaskCreating" @statusCreateTestInput="handleStatusCreateTestInput"
                    :countTime="countTime" />
                <succes-create-entrance-input v-if="statusCreateTestInput === STATUS_TO_DO"
                    @closeModal="openScheduleTestInput = false" @reloadPage=" querySever();"
                    :idTaskCreating="createdTestInputScheduleId || successCreateData?.test_input_schedule_id || idTaskCreating"
                    :customerId="selectedCustomer?.id || idCustomer"
                    :successCreateData="successCreateData" />
                <cancel-create-input v-if="statusCreateTestInput === STATUS_FAlURE"
                    @closeModal="openScheduleTestInput = false" />
                <overload-create-test-input v-if="statusCreateTestInput === STATUS_OVER_LOADING"
                    @closeModal="openScheduleTestInput = false" />
            </el-row>
        </el-dialog>
        <el-dialog title="Đặt lịch test đầu vào" class="responsive" :visible.sync="openChoseOption">
        </el-dialog>
        <el-dialog class="dialogSetting" :visible.sync="dialogFilterVisible" width="800px">
            <FilterSearch :isGDKV="isGDKV" @close="dialogFilterVisible = false" :tableColumnsOption="filterOption"
                :isUpdate="isUpdateFilterOption" />
        </el-dialog>

        <el-dialog class="dialogSetting" :visible.sync="dialogFilterTableVisible" width="800px">
            <filterTable :tableColumnLabels="tableColumnsOption" :is-update="isUpdateTableColumnsOption" />
        </el-dialog>

        <el-dialog :title="'Khách hàng: ' + selectedCustomer.name + ' đóng tiền'" class="dialogSetting"
            :visible.sync="dialogInputAmount" width="800px">
            <InputAmount @reloadSaleInput="importSaleList(form)" @close="dialogInputAmount = false"
                :is_show="dialogInputAmount" :customer="selectedCustomer" />
        </el-dialog>

        <el-dialog title="Import dữ liệu" :show-close="false" :visible.sync="importSalesVisible">
            <DialogimportSales @close="importSalesVisible = false"></DialogimportSales>
        </el-dialog>

        <el-dialog title="Chi tiết phím nóng" :visible.sync="dialogHotKeyDetail">
            <hr style="border: none; border-bottom: 1px solid #c0c4cc7d" class="mb-4">
            <hot-key-detail :hotkey="selectHotkey" :hot_key_detail="selectHotkeyDetail"></hot-key-detail>
        </el-dialog>

        <el-dialog title="Import khách hàng" :visible.sync="importCustomerVisible">
            <dialogimport-customer @close="importCustomerVisible = false" @reload="querySever()"></dialogimport-customer>
        </el-dialog>

        <el-dialog title="Tra cứu thông tin khách hàng của sale đã nghỉ việc"
            :visible.sync="dialogSearchInfoCustomerVisible" width="70%">
            <hr>
            <dialog-search-info-customer></dialog-search-info-customer>
        </el-dialog>

        <el-dialog title="Nhắc nhở chăm sóc học viên cuối khóa" :visible.sync="dialogNotificationSupportEndCourse"
            width="80%" :show-close="false">
            <hr>
            <dialog-notification-support-end-course :is_show="dialogNotificationSupportEndCourse"
                @close="dialogNotificationSupportEndCourse = false"></dialog-notification-support-end-course>
        </el-dialog>

      <el-dialog title="Công việc xử lý với khách hàng" :visible.sync="dialogTask" width="80%" :show-close="false">
        <div class="mb-2 d-flex justify-content-end">
            <el-button v-if="[3,4,5,6,7].includes(keyAccount)" @click="handleCreateTask()" size="small" rouned icon="el-icon-plus" type="primary">Tạo task</el-button>
        </div>
        <hr>
        <dialogHandleTask :is_show="dialogTask" @update-type-task-customer="updateTypeTaskCustomer" :customer="selectedCustomer" @close="dialogTask=false"></dialogHandleTask>
      </el-dialog>

      <el-dialog title="Tạo task việc" :visible.sync="dialogCreateTask" width="70%" :show-close="false">
        <hr>
        <dialogHandleCreateTask @change-type-new-task="changeTypeNewTask" :is_show="dialogCreateTask" @close="dialogCreateTask=false" :customer="selectedCustomer"></dialogHandleCreateTask>
      </el-dialog>
      <el-dialog title="HƯỚNG DẪN ĐĂNG KÝ TEST ĐẦU VÀO CẤP 2" :visible.sync="isNotificationSupport" width="40%">
        <hr style="margin-top: -20px">
        <NotificationSupportMiddleSchool />
      </el-dialog>
    </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FilterSearch from "./components/FilterSearch.vue";
import filterTable from "./components/FilterTable.vue";
import InputAmount from "./components/InputAmount.vue";
import { BRANCH_LIST, HIERARCHY } from "@/core/services/store/service.module";
import lodash from 'lodash-es';
import deepdash from 'deepdash-es';
import { debounce } from 'lodash';
import { mapGetters } from "vuex";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { CHECK_BEFORE_CONSULT_SCHEDULE, CUSTOMER_LIST, CHANGE_LEVEL_1E } from "@/core/services/store/customer/customer.module";
import DatLichTuVan from "@/views/pages/customer/dat-lich-tu-van";
import DialogimportSales from "@/views/pages/customer/DialogimportSales.vue";
import Swal from 'sweetalert2';
import TestScheduleComplete from "@/views/pages/customer/test-schedule-complete";
import RescheduleTestInput from "@/views/pages/customer/reschedule-test-input.vue";
import { CREATE_TEST_INPUT_SCHEDULE_CUSTOMER } from "@/core/services/store/customer/testInput.module";
import LoadingCreateTestInput from "./components/LoadingCreateTestInput.vue";
import SuccesCreateInput from "./components/SuccesCreateInput.vue";
import SuccesCreateEntranceInput from "./components/SuccesCreateEntranceInput.vue";
import CancelCreateInput from "./components/CancelCreateInput.vue";
import OverloadCreateTestInput from "./components/OverloadCreateTestInput.vue";
import { GET_SPEAKING_BY_TEST_INPUT } from "@/core/services/store/customer/testInput.module";
import {
    STATUS_CREATE,
    STATUS_FAlURE,
    STATUS_OVER_LOADING,
    STATUS_PENDING,
    STATUS_TO_DO
} from "@/core/config/testInput/testInputOption";
import router from "../../../router";
import {
    STATUS_CANCEL,
    STATUS_CHOOSE_OPTION, STATUS_NOT_ACTIVE,
    STATUS_ONLY_GENERAL,
    STATUS_SUCCESS,
    TYPE_SPEAKING_AI,
    Mentor_English_Mastery_ID
} from "@/core/config/testInput/testInputOption";
import {buildScheduleBandPayload} from "@/core/config/testInput/scheduleFieldOption";
import OptionCreateTestInput from "./components/OptionCreateTestInput.vue";
import ScheduleEntranceTestDialog from "./components/ScheduleEntranceTestDialog.vue";
import EntranceListDialog from "./components/EntranceListDialog.vue";
import EntranceNeedInfoDialog from "./components/EntranceNeedInfoDialog.vue";
import EntranceBlockConsultDialog from "./components/EntranceBlockConsultDialog.vue";
import { STORE_ONLY_GENERAL, STORE_SPEAKING_API } from "@/core/services/store/customer/testInput.module";
import { REGISTER_ENTRANCE_EXAM, CHECK_ENTRANCE_EXAM_BEFORE_CONSULT, GET_LIST_EXAM } from "@/core/services/store/customer/entrance.module";
import { GET_IMPORT_SALE_EXPECTED_LIST } from "@/core/services/store/customer/customer.module";
import { SERVICE_CONFIG_CUSTOMER_GET } from "@/core/services/store/service.module";
import { LEVEL_CONSULTED } from "@/core/config/customer/customerOption";
import { GET_CENTERS } from "@/core/services/store/center/center.module";
import HotKeyDetail from "@/views/pages/customer/HotKeyDetail.vue";
import DialogimportCustomer from "@/views/pages/customer/DialogimportCustomer.vue";
import DialogSearchInfoCustomer from "./dialogSearchInfoCustomer.vue";
import DialogHandleTask from "./dialogHandleTask.vue";
import DialogHandleCreateTask from "./dialogHandleCreateTask.vue";
import DialogNotificationSupportEndCourse from "./DialogNotificationSupportEndCourse.vue";
import NotificationSupportMiddleSchool from "@/views/pages/customer/components/NotificationSupportMiddleSchool.vue";
const _ = deepdash(lodash);

export default {
    name: "ListCustomer",
    components: {
        NotificationSupportMiddleSchool,
        DialogHandleCreateTask,
        DialogHandleTask,
        DialogNotificationSupportEndCourse,
        DialogSearchInfoCustomer,
        DialogimportCustomer,
        HotKeyDetail,
        OptionCreateTestInput,
        ScheduleEntranceTestDialog,
        EntranceListDialog,
        EntranceNeedInfoDialog,
        EntranceBlockConsultDialog,
        OverloadCreateTestInput,
        CancelCreateInput,
        SuccesCreateInput,
        SuccesCreateEntranceInput,
        LoadingCreateTestInput,
        RescheduleTestInput,
        TestScheduleComplete,
        DatLichTuVan,
        FilterSearch,
        filterTable,
        InputAmount,
        DialogimportSales,
    },

    data() {
        return {
            isCVHT : false,
            isNotificationSupport: false,
            LEVEL_CONSULTED: LEVEL_CONSULTED,
            filterOptionDefault: {
                name: true,
                level: true,
                dieu_kien_tai_chinh: true,
                ngay_hen: true,
                sale: true,
                view_as: true,
                branch_id: true,
                nguon: true,
                trang_thai_tu_van: true,
                center: true,
                hot_key: true,
            },
            debounceQuerySever: null,
            filterOption: {},
            isGDKV: false,
            paging: {
                current_page: 1,
                per_page: 50,
                total: 0,
            },
            dialogImageUrl: '',
            loading: false,
            currentPage: 1,
            selectDate: '',
            defaultValue: '',
            imageHierarchy: {
                '5': `${process.env.VUE_APP_BASE_URL}media/hierarchy/gdvp.png`,
                '1': `${process.env.VUE_APP_BASE_URL}media/hierarchy/sl.png`,
                '2': `${process.env.VUE_APP_BASE_URL}media/hierarchy/se.png`,
                '3': `${process.env.VUE_APP_BASE_URL}media/hierarchy/s.png`,
                '4': `${process.env.VUE_APP_BASE_URL}media/hierarchy/si.png`
            },
            total: { tong: 0, so_luot: 0 },
            options: [],
            form: {
                name: '',
                selectDate: '',
                view_as: 2,
                branch_id: '',
                sale: null,
                level: '',
                dieu_kien_tai_chinh: '',
                dateRange: null,
                nguon: '',
                center_id: '',
                ngay_hen: '',
                hot_key: '',
                ma_gioi_thieu: '',
                is_export: 0
            },

            branches: [],
            centers: [],
            watchAs: [
                {
                    id: 1,
                    value: 'Đội kinh doanh',
                    label: 'Đội'
                },
                {
                    id: 2,
                    value: 'Cá nhân',
                    label: 'Cá nhân'
                }
            ],
            tableColumnsOptionDefault: {
                nguon: true,
                total_input_amount: true,
                name: true,
                ngay_sinh: true,
                phone: true,
                co_quan: true,
                object_customer: true,
                task: true,
                level: true,
                ngay_hen: true,
                trung_tam_hen: true,
                chi_nhanh_hen: true,
                hot_key: true,
                tu_van_vien: true,
                muc_tieu: true,
                trang_thai_tu_van: true,
                // khach_hang_cua: true,
                kenh_khach_hang: true,
                ma_gioi_thieu: true,
                hanh_dong: true,
                // test
            },
            dialogCheckDebt: false,
            tableColumnsOption: {},
            optionLevel: [
                { id: '1A', value: '1A - Nhu cầu' },
                { id: '1E', value: '1E - Lịch hẹn' },
                { id: '1C', value: '1C - Trống' },
                { id: '2A', value: '2A - Có lịch hẹn tư vấn' },
                { id: '2B', value: '2B - Delay hẹn' },
                { id: '2C', value: '2C - Hủy hẹn' },
                { id: '2E', value: '2E - Đặt lịch đóng tiền' },
                { id: '3', value: '3 - Tư vấn' },
                { id: '3A', value: '3A - Đăng ký' },
                { id: '3B', value: '3B - Khách hàng đến' },
                { id: '3C', value: '3C - Không đăng ký' },
                { id: '3E', value: '3E - Phân vân' },
                { id: '4A', value: '4A - Đã đóng trên 1200k' },
                { id: '4B', value: '4B - Đóng tiền dưới 1200k' },
                { id: '4D', value: '4D - Rút tiền' },
                { id: '5A', value: '5A - Đã đăng ký khóa combo' },
                { id: '5B', value: '5B - Đã đăng ký khóa lẻ' },
                { id: '5D', value: '5D - Hủy đăng ký' },
                { id: '6', value: '6 - Đang học' },
                { id: '7', value: '7 - Đợi lớp' },
                { id: '8', value: '8 - Ngừng học' },
            ],
            optionFinance: [
                { id: 0, value: 'Từ 0 đến dưới 5 triệu' },
                { id: 1, value: 'Từ 5 đến dưới 10 triệu' },
                { id: 2, value: 'Từ 10 đến dưới 20 triệu' },
                { id: 3, value: 'Từ 20 đến dưới 30 triệu' },
                { id: 4, value: 'Từ 30 đến dưới 40 triệu' },
                { id: 5, value: 'Từ 40 đến dưới 50 triệu' },
                { id: 6, value: 'Từ 50 triệu trở lên' },
            ],
            optionTypeAdvise: [
                { id: 1, value: 'Đã tư vấn' },
                { id: 2, value: 'KH delay' },
                { id: 3, value: 'KH huỷ' },
            ],
            optionSource: [
                { id: 1, value: 'Nhân' },
                { id: 2, value: 'Nội bộ' },
                { id: 3, value: 'Ấm nóng' },
                { id: 4, value: 'Tiếp xúc lạnh' },
                { id: 5, value: 'Tái đăng ký' },
                { id: 6, value: 'Liên kết trường' },
                { id: 7, value: 'Lạnh' },
                { id: 8, value: 'Facebook ads' },
                { id: 9, value: 'Google ads' },
                { id: 10, value: 'Tiktok ads' },
                { id: 11, value: 'Vệ tinh' },
            ],

            phimNongDeFine: [
                { id: 1, value: "Tài chính" },
                { id: 2, value: "Phương pháp học" },
                { id: 3, value: "Gia đình/Mối quan hệ" },
                { id: 4, value: "Thời gian" },
                { id: 5, value: "Định hướng học IELTS" },
                { id: 6, value: "Quyết định và lựa chọn" },
                { id: 7, value: "Khoảng cách" },
                { id: 8, value: "Nỗi sợ" },
                { id: 9, value: "Khác" },
            ],
            task_meta: {
                1: { type: 'info', label: 'Chưa có Task' },
                2: { type: 'danger', label: 'Có task mới' },
                3: { type: 'warning', label: 'Đang xử lý task' },
                4: { type: 'success', label: 'Hoàn thành task' },
            },
            default_meta: { type: '', label: '' },
            tableData: [],
            dataSaleMonth: [],
            dialog: {
                title: ''
            },
            link: `${process.env.VUE_APP_BASE_URL}`,
            customer_id: null,
            ngay_hen: null,
            customer_name: null,
            customer_phone: null,
            dialogFormVisible: false,
            dialogHotKeyDetail: false,
            dialogTestScheduleCompleteVisible: false,
            openScheduleTestInput: false,
            scheduleEntranceTestDialogVisible: false,
            entranceNeedInfoDialogVisible: false,
            entranceBlockConsultDialogVisible: false,
            checkingConsultId: null,
            loadingListExamId: null,
            entranceScheduleConfirmLoading: false,
            entranceListDialogVisible: false,
            selectedListExam: [],
            testInput: null,
            idCustomerSelected: null,
            isDisable: false,
            displayTestInput: true,
            statusCreateTestInput: STATUS_CHOOSE_OPTION,
            idTaskCreating: null,
            createdTestInputScheduleId: null,
            STATUS_TO_DO: STATUS_TO_DO,
            STATUS_PENDING: STATUS_PENDING,
            STATUS_FAlURE: STATUS_FAlURE,
            STATUS_OVER_LOADING: STATUS_OVER_LOADING,
            STATUS_CREATE: STATUS_CREATE,
            idCustomer: null,
            countTime: 60,
            openChoseOption: false,
            STATUS_CHOOSE_OPTION: STATUS_CHOOSE_OPTION,
            selectedCustomer: {},
            STATUS_ONLY_GENERAL: STATUS_ONLY_GENERAL,
            STATUS_SPEAKING_AI: TYPE_SPEAKING_AI,
            successCreateData: {},
            selectHotkey: '',
            selectHotkeyDetail: '',
            dialogFilterVisible: false,
            dialogFilterTableVisible: false,
            dialogInputAmount: false,
            isUpdateTableColumnsOption: false,
            isUpdateFilterOption: false,
            importSalesVisible: false,
            importCustomerVisible: false,
            dialogSearchInfoCustomerVisible: false,
            dialogNotificationSupportEndCourse: false,
            dialogTask: false,
            dialogCreateTask: false,
            bandType: null
        }
    },

    created() {
        this.debounceQuerySever = debounce(this.querySever, 2000);
    },

    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Danh sách", route: "customer-list" },
            { title: "Khách hàng", icon: 'fas fa-users' }
        ]);
        if(this.currentUser?.user_positions.find((item) => {return item?.position == "CVHT"})){
            this.isCVHT = true;
            this.watchAs.push({
                id: 3,
                value: 'Đội văn phòng',
                label: 'Đội văn phòng'
            })
        }
        const searchQuery = this.$route?.query?.search || this.$route?.query?.name;
        if (searchQuery) {
            this.form.name = searchQuery;
            this.querySever();
        }

        this.getConfig();
        this.getCenter();
        if (this.currentUser.area_id > 0 && this.currentUser.account_type.name == 'GĐKV') {
            this.isGDKV = true;
            this.getBranch();
        } else {
            if (_.indexOf(['TPNS', 'TPOnline', 'TPTT'], this.currentUser?.account_type) > -1) {
                this.watchAs.unshift({
                    id: 0,
                    value: 'TPhòng/Giám đốc',
                    label: 'TP/GĐ'
                });
            }
            this.statusCreateTestInput = this.isPilot ? this.STATUS_CHOOSE_OPTION : this.STATUS_CREATE
            this.form.view_as = 2;
            this.querySever();
            this.handleChangeBranch()
        }
        this.checkShowBtnDetailTest()
    },
    methods: {
        debouncedQueryServer: _.debounce(function () {
            this.querySever();
        }, 1000),

        checkShowBtnDetailTest(listExam) {
            return listExam?.length > 0;
        },
        checkTranhChap(customer) {
            return (customer.created_user === this.currentUser.id && customer.ma_gioi_thieu - 100000 !== this.currentUser.id && customer.ma_gioi_thieu > 0)
                || (customer.created_user !== this.currentUser.id && customer.ma_gioi_thieu - 100000 !== customer.created_user);
        },
        normalizer: function (node) {
            return {
                id: node.id,
                label: node.name,
            }
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.querySever({ page: val });
        },

        submit() {
            this.querySever();
        },
        chooseSale() {
            if (this.form.sale) {
                this.form.view_as = null;
            } else {
                if (this.form.view_as != 3) {
                    this.form.view_as = null;
                }
            }
        },
        getImageHierarchy(account_type) {
            return this.imageHierarchy[account_type];
        },
        getBranch() {
            this.$store.dispatch(BRANCH_LIST)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({ type: 'warning', message: `${response.message}`, showClose: true });
                    } else {
                        this.branches = response.data;
                        this.form.branch_id = response?.data?.length > 0 ? response?.data[0].id : 0;
                        this.querySever({ branch_id: this.form.branch_id });
                        this.handleChangeBranch()
                    }
                })
        },

        getCenter() {
            this.$store.dispatch(GET_CENTERS, {
                limit: 1000000
            }).then((data) => {
                this.centers = data.data.data;
            });
        },
        handleChangeBranch() {
            if (this.form.branch_id > 0) {
                this.$store.dispatch(HIERARCHY, { branch_id: this.form.branch_id })
                    .then((response) => {
                        this.form.sale = null;
                        this.options = response.data;
                    })
            } else {
                this.form.sale = null;
                this.$store.dispatch(HIERARCHY, { branch_id: this.currentUser.profile.chi_nhanh_id })
                    .then((response) => {
                        this.form.sale = null;
                        this.options = response.data;
                    })
            }
        },

        updateUrlQuery(params = {}) {
            const q = { ...this.$route.query };
            if (params.search) {
                q.search = params.search;
            } else {
                delete q.search;
            }

            if (this.$router && typeof this.$router.replace === 'function') {
                this.$router.replace({ query: q }).catch(() => { });
            }
        },

        changeWatchAs() {
           if (this.form.view_as == 3 && this.form.sale !== null) {
                this.form.sale = null;
                return;
           }
           this.querySever();

        },
        querySever(customProperties) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.loading = true;

            let params = this.mergeParams(customProperties);
            this.importSaleList(params);
            this.updateUrlQuery(params);
            this.currentPage = 1;
            this.$store.dispatch(CUSTOMER_LIST, params)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({ type: 'warning', message: `${response.message}`, showClose: true });
                    } else {
                        this.tableData = response.data;
                        this.total = response.data.total;
                        this.paging = response.pagination
                    }
                    this.loading = false;
                }).finally(() => {
                    this.form.is_export = 0;
                    loading.close();
                })
        },
        taskMeta(status) {
            return this.task_meta[status] || this.default_meta;
        },

        mergeParams(customProperties) {
            let params = {
                page: this.paging.current_page,
                per_page: this.paging.per_page,
                view_as: this.form.view_as,
            };
            if (this.form.dateRange) {
                params = _.merge(params, { ngay_hen: this.form.dateRange })
            }
            if (this.form.level) {
                params = _.merge(params, { level: this.form.level })
            }
            if (this.form.name) {
                params = _.merge(params, { search: this.form.name })
            }
            if (this.form.dieu_kien_tai_chinh) {
                params = _.merge(params, { dieu_kien_tai_chinh: this.form.dieu_kien_tai_chinh })
            }
            if (this.form.branch_id) {
                params = _.merge(params, { branch_id: this.form.branch_id })
            }
            if (this.form.nguon) {
                params = _.merge(params, { nguon: this.form.nguon })
            }
            if (this.form.sale) {
                params = _.merge(params, { sale: this.form.sale })
            }
            if (this.form.trang_thai_tu_van) {
                params = _.merge(params, { trang_thai_tu_van: this.form.trang_thai_tu_van })
            }
            if (this.form.center_id) {
                params = _.merge(params, { center_id: this.form.center_id })
            }
            if (this.form.hot_key) {
                params = _.merge(params, { hot_key: this.form.hot_key })
            }
            if (this.form.ma_gioi_thieu) {
                params = _.merge(params, { ma_gioi_thieu: this.form.ma_gioi_thieu })
            }
            if (this.form.is_export) {
                params = _.merge(params, { is_export: this.form.is_export })
            }
            params = _.merge(params, customProperties);
            return params;
        },
        closePopup() {
            this.dialogFormVisible = false
        },
        handleDatLichTuVan(item) {
            if (item.nguon === '' || item.hot_key == []) {
                Swal.fire('Thông báo', 'Khách hàng cần có đầy đủ nguồn và phím nóng mới có thể đặt lịch!', 'error');
                return false;
            }
            if (!this.isPilotEntrance) {
                this.openConsultDialog(item);
                return;
            }
            if (this.checkingConsultId !== null) return;
            this.checkingConsultId = item.id;
            this.$store.dispatch(CHECK_ENTRANCE_EXAM_BEFORE_CONSULT, { customer_id: item.id }).then(() => {
                this.openConsultDialog(item);
            }).catch((error) => {
                if (error?.status === 400) {
                    this.selectedCustomer = item;
                    this.entranceBlockConsultDialogVisible = true;
                    return;
                }
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Kiểm tra điều kiện đặt lịch tư vấn thất bại',
                    showClose: true
                });
            }).finally(() => {
                this.checkingConsultId = null;
            });
        },
        openConsultDialog(item) {
            this.displayTestInput = item.test_input_schedule.length <= 0;
            this.dialog.title = item.ngay_hen ? 'Đổi lịch tư vấn' : 'Đặt lịch tư vấn'
            this.customer_id = item.id
            this.ngay_hen = item.ngay_hen_old
            this.customer_phone = item.phone
            this.customer_name = item.name
            this.dialogFormVisible = true
            this.isUpdate = true
        },
        viewBlockingEntranceExams() {
            Promise.resolve(this.handleDetailEntrance(this.selectedCustomer)).finally(() => {
                this.entranceBlockConsultDialogVisible = false;
            });
        },
        handleCheckDebt(item) {
            this.selectedCustomer = item;
            this.dialogCheckDebt = true;
        },
        handleDatLichDongTien(item) {
            this.$store.dispatch(CHECK_BEFORE_CONSULT_SCHEDULE, {
                'id': item.id,
                'phone': item.phone
            })
                .then((response) => {
                    if (response.status === 422) {
                        this.$notify({
                            title: 'Warning',
                            message: `Serve đang bận, vui lòng thử lại sau: ${response.data.message}`,
                            type: 'warning'
                        });
                    } else {
                        if (response.data.check) {
                            Swal.fire('Thông báo', 'Đã có sale khác đặt lịch, bạn không thể đặt lịch cho khách hàng nữa!', 'error');
                            return false;
                        } else {
                            this.$router.push({ name: "advise-center", query: { customer_id: item?.id, payment: 1 } });
                        }
                    }
                });
        },
        completedUpdate(item) {
            if (item) {
                let index_customer = this.tableData.findIndex(i => i.id === item.id);
                let data = this.tableData[index_customer];
                _.merge(data, item);

                this.dialogFormVisible = false
                if (item.check_test_input) {
                    this.dialogTestScheduleCompleteVisible = true
                } else {
                    if (this.dialog.title == 'Đổi lịch tư vấn') {
                        this.$message({ type: 'success', message: `Đổi lịch tư vấn thành công`, showClose: true });
                    } else {
                        this.$message({ type: 'success', message: `Đặt lịch tư vấn thành công`, showClose: true });
                    }
                }
            }
            this.dialogFormVisible = false
            this.querySever();

        },
        closePopupTestSchedule() {
            this.dialogTestScheduleCompleteVisible = false
        },
        handleInfoTestInput(item) {
            this.testInput = item;
            this.testInput.customer_id = this.idCustomerSelected
        },
        createScheduleTestInput() {
            if (this.statusCreateTestInput === STATUS_CHOOSE_OPTION) {
                return
            }
            const payload = buildScheduleBandPayload({
                payload: this.testInput,
                bandType: this.bandType,
                masteryCenterId: Mentor_English_Mastery_ID
            });
            this.isDisable = true;
            console.log(payload, "CREATE_TEST_INPUT_SCHEDULE_CUSTOMER");
            this.$store.dispatch(CREATE_TEST_INPUT_SCHEDULE_CUSTOMER, payload).then((data) => {
                setTimeout(() => {
                    this.statusCreateTestInput = STATUS_PENDING;
                })
                this.idTaskCreating = data?.data?.id;
                this.createdTestInputScheduleId = data?.data?.test_input_schedule_id;
                // this.openScheduleTestInput = false;
            }).catch((error) => {
                this.$message({ type: 'error', message: `${error.data.message}`, showClose: true });
                this.testInput.time = null;
                this.testInput.ngay_hen = null;
            }).finally(() => {
                // this.querySever();
                this.isDisable = false;
            })
        },
        selectCustomer(customer) {
            this.idCustomerSelected = customer.id;
            this.selectedCustomer = customer;
            if (!this.isPilotEntrance) {
                // OLD: mở dialog OptionCreateTestInput
                this.openScheduleTestInput = true;
                return;
            }
            this.scheduleEntranceTestDialogVisible = true;
        },
        getEntranceNeed(customer) {
            return customer?.is_need_entrance_exam;
        },
        openEntranceNeedInfo(customer) {
            this.idCustomerSelected = customer.id;
            this.selectedCustomer = customer;
            this.entranceNeedInfoDialogVisible = true;
        },
        handleEntranceNeedRegisterAgain() {
            this.entranceNeedInfoDialogVisible = false;
            this.scheduleEntranceTestDialogVisible = true;
        },
        goToTestInputDetail({ customerId, taskId, status, is_latest } = {}) {
            if (this.isPilotEntrance) {
                if (!taskId) return;
                const query = {};
                if (status != null) query.status = status;
                if (customerId) query.customer_id = customerId;
                if (is_latest === '1' || is_latest === '0') {
                    query.is_latest = is_latest;
                }
                router.push({
                    name: 'customer-test-input-entrance',
                    params: { id: taskId },
                    query
                });
                return;
            }
            if (!customerId) return;
            router.push({
                name: 'customer-test-input-schedule',
                params: { id: customerId },
                query: status != null ? { status } : {}
            });
        },
        // NEW: thay confirmOption cũ - nhận kết quả chọn từ ScheduleEntranceTestDialog
        async confirmEntranceSchedule(payload = {}) {
            this.entranceScheduleConfirmLoading = true;
            try {
                if (payload.type === 'basic') {
                    await this.createSpeakingAiEntranceSchedule(payload.center_id);
                    return;
                }
                if (payload.type === 'higher') {
                    await this.registerEntranceExamSchedule(payload);
                    return;
                }
                if (payload.type === 'mastery') {
                    await this.createMasteryEntranceSchedule(payload);
                }
            } finally {
                this.entranceScheduleConfirmLoading = false;
            }
        },
        closeEntranceScheduleDialog() {
            this.scheduleEntranceTestDialogVisible = false;
            this.entranceScheduleConfirmLoading = false;
        },
        // Basic: tương đương option "Đặt lịch test speaking với AI" cũ
        createSpeakingAiEntranceSchedule(centerId) {
            const payload = {
                name: this.selectedCustomer?.name,
                phone: this.selectedCustomer?.phone,
                customer_id: this.selectedCustomer?.id,
                center_id: centerId
            };
            this.statusCreateTestInput = this.STATUS_SPEAKING_AI;
            return this.$store.dispatch(STORE_SPEAKING_API, payload).then((data) => {
                if (!data.data) {
                    this.$message({
                        message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
                        type: 'warning'
                    });
                    return;
                }
                const testInputScheduleId = data?.data?.id;
                if (!testInputScheduleId || data?.error) {
                    return;
                }
                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });
                this.closeEntranceScheduleDialog();
                this.goToTestInputDetail({
                    customerId: this.selectedCustomer?.id,
                    taskId: testInputScheduleId,
                    status: this.statusCreateTestInput,
                    is_latest: '1'
                });
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đặt lịch Speaking AI thất bại',
                    showClose: true
                });
            });
        },
        // Cao hơn Basic: đăng ký thi đầu khóa
        registerEntranceExamSchedule({ center_id, marking_exam_shift_id }) {
            if (!this.selectedCustomer?.user_id) {
                this.$message({
                    type: 'warning',
                    message: 'Không tìm thấy thông tin học viên để đăng ký lịch thi. Vui lòng thử lại.',
                    showClose: true
                });
                return Promise.resolve();
            }
            return this.$store.dispatch(REGISTER_ENTRANCE_EXAM, {
                user_id: this.selectedCustomer.user_id,
                center_id: center_id,
                marking_exam_shift_id: Number(marking_exam_shift_id)
            }).then((res) => {
                this.$message({
                    type: res?.error ? 'warning' : 'success',
                    message: res?.message || 'Đăng ký lịch thi đầu khóa thành công',
                    showClose: true
                });
                if (res?.error) {
                    return;
                }
                this.closeEntranceScheduleDialog();
                this.querySever();
                const retakeId = res?.data?.id;
                if (retakeId) {
                    this.redirectToEntranceExamSchedule(retakeId, this.selectedCustomer?.id);
                }
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đăng ký lịch thi đầu khóa thất bại',
                    showClose: true
                });
            });
        },
        // Mentor English Mastery: tương đương option "test với admin test" cũ
        createMasteryEntranceSchedule({ testInput }) {
            const payload = buildScheduleBandPayload({
                payload: { ...testInput, customer_id: this.selectedCustomer?.id },
                bandType: 1,
                masteryCenterId: Mentor_English_Mastery_ID
            });
            this.isDisable = true;
            return this.$store.dispatch(CREATE_TEST_INPUT_SCHEDULE_CUSTOMER, payload).then((data) => {
                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });
                this.closeEntranceScheduleDialog();
                this.idTaskCreating = data?.data?.id;
                this.createdTestInputScheduleId = data?.data?.test_input_schedule_id;
                this.statusCreateTestInput = STATUS_PENDING;
                this.openScheduleTestInput = true;
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đặt lịch test đầu vào thất bại',
                    showClose: true
                });
            }).finally(() => {
                this.isDisable = false;
            });
        },
        handleStatusCreateTestInput(status, customerId, dataResponse) {
            this.idCustomer = customerId;
            this.successCreateData = dataResponse;
            setTimeout(() => {
                this.statusCreateTestInput = status;
            })

        },
        handleDetailEntrance(customer) {
            // Không phải thí điểm test đầu vào mới
            if (!this.isPilotEntrance) {
                this.handleDetailTestInput(customer);
                return;
            }

            // Thí điểm test đầu vào
            if (this.loadingListExamId !== null) return;
            this.loadingListExamId = customer.id;
            return this.$store.dispatch(GET_LIST_EXAM, { customer_id: customer.id }).then((res) => {
                const listExam = res?.data || [];
                if (!listExam.length) return;

                if (listExam.length > 1) {
                    this.selectedCustomer = customer;
                    this.selectedListExam = listExam;
                    this.entranceListDialogVisible = true;
                    return;
                }

                return this.openEntranceExamDetail(customer, listExam[0], '1');
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Lấy danh sách ca test thất bại',
                    showClose: true
                });
            }).finally(() => {
                this.loadingListExamId = null;
            });
        },
        handleViewEntranceExam(item) {
            this.entranceListDialogVisible = false;
            const latest = this.selectedListExam[0];
            const is_latest = latest && String(latest.id) === String(item.id) ? '1' : '0';
            this.openEntranceExamDetail(this.selectedCustomer, item, is_latest);
        },
        openEntranceExamDetail(customer, exam, is_latest = '1') {
            if (!exam) return;
            if (exam.exam_type === 'Test đầu vào' || exam.exam_type === 'Test sơ bộ') {
                return this.handleDetailTestInput(customer, exam.id, is_latest);
            }
            if (exam.exam_type === 'Thi đầu khóa') {
                this.redirectToEntranceExamSchedule(exam.id, customer?.id, is_latest);
            }
        },
        redirectToEntranceExamSchedule(retakeId, customerId, is_latest = '1') {
            const query = { is_latest };
            if (customerId) query.customer_id = customerId;
            this.$router.push({
                name: "customer-entrance-exam-schedule",
                params: { marking_exam_retake_id: retakeId },
                query
            });
        },
        handleDetailTestInput(customer, retakeId, is_latest) {
            const schedules = customer?.test_input_schedule || [];
            const schedule = retakeId != null
                ? schedules.find((item) => String(item.id) === String(retakeId))
                : schedules[0];
            if (!schedule) return;

            const statusCustomer = schedule.status;
            const latestQuery = (is_latest === '1' || is_latest === '0') ? { is_latest } : {};
            if (+statusCustomer === this.STATUS_ONLY_GENERAL) {
                this.goToTestInputDetail({
                    customerId: customer.id,
                    taskId: retakeId ?? schedule.id,
                    status: this.statusCreateTestInput,
                    ...latestQuery
                });
                return
            }
            return this.$store.dispatch(GET_SPEAKING_BY_TEST_INPUT, { id: schedule.id }).then((data) => {
                if (data.data.status === null || data.data.status === undefined) {
                    return;
                }
                if (data.data.sub_type) {
                    this.statusCreateTestInput = this.STATUS_SPEAKING_AI;
                }
                if ([this.STATUS_TO_DO, STATUS_SUCCESS, STATUS_CANCEL, STATUS_NOT_ACTIVE].includes(+data.data.status)) {
                    this.goToTestInputDetail({
                        customerId: customer.id,
                        taskId: retakeId ?? schedule.id,
                        status: this.statusCreateTestInput,
                        ...latestQuery
                    });
                    return
                }
                if (+data.data.status == STATUS_PENDING) {
                    let secondTimeCreate = (new Date(data?.data?.created_at).getTime()) / 1000;
                    let secondCurrent = (new Date().getTime()) / 1000;
                    let TimeRemaining = 60 - (secondCurrent - secondTimeCreate)
                    if (+TimeRemaining > 0) {
                        this.countTime = Math.max(TimeRemaining, 60);
                        setTimeout(() => {
                            this.statusCreateTestInput = STATUS_PENDING;
                        })
                        this.idTaskCreating = data?.data?.id;
                        return;
                    }
                    this.selectCustomer(customer)
                    return
                }
                this.selectCustomer(customer)
            }).catch(() => {

            }).finally(() => {

            })
            //
        },
        resetModal() {
            this.statusCreateTestInput = this.isPilot ? this.STATUS_CHOOSE_OPTION : this.STATUS_CREATE
            this.countTime = 60
            this.bandType = null
            this.testInput = null
            this.createdTestInputScheduleId = null
        },
        confirmOption(isOnlyGeneral, centerId = undefined, registerType = null, optionPayload = {}) {
            if (isOnlyGeneral == 3) {
                this.isNotificationSupport = true
            }
            if (registerType && isOnlyGeneral !== 2) {
                this.bandType = registerType
            }
            if (isOnlyGeneral) {
                // this.openScheduleTestInput = false;
                let payload = {
                    name: this.selectedCustomer?.name,
                    phone: this.selectedCustomer?.phone,
                    customer_id: this.selectedCustomer?.id,
                    center_id: centerId,
                    ...optionPayload
                }
                let url = '';
                switch (isOnlyGeneral) {
                    case 1:
                        url = STORE_SPEAKING_API;
                        this.statusCreateTestInput = this.STATUS_SPEAKING_AI;
                        break;
                    case 2:
                        url = STORE_ONLY_GENERAL;
                        break;
                }

                this.$store.dispatch(url, payload).then((data) => {
                    if (!data.data && isOnlyGeneral == 1) {
                        this.$message({
                            message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
                            type: 'warning'
                        });
                        return;

                    }
                    const testInputScheduleId = data?.data?.id;
                    if (!testInputScheduleId || data?.error) {
                        return;
                    }
                    this.goToTestInputDetail({
                        customerId: this.selectedCustomer?.id,
                        taskId: testInputScheduleId,
                        status: this.statusCreateTestInput,
                        is_latest: '1'
                    });
                }).catch((e) => {
                    this.openScheduleTestInput = false
                })
                return
            }
            this.statusCreateTestInput = this.STATUS_CREATE;
        },
        shouldShow(fieldKey) {
            return this.filterOption[fieldKey] === true;
        },
        handleInputAmount(customer) {
            this.selectedCustomer = customer;
            this.dialogInputAmount = true;
        },
        getConfig() {
            this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_GET, { config_type: '2,3,', model: 'customer' })
                .then((res) => {
                    this.filterOption = res.data[2] ? { ...this.filterOptionDefault, ...res.data[2] } : this.filterOptionDefault;
                    this.tableColumnsOption = res.data[3] ? { ...this.tableColumnsOptionDefault, ...res.data[3] } : this.tableColumnsOptionDefault;
                    this.isUpdateFilterOption = res.data[2] ? true : false;
                    this.isUpdateTableColumnsOption = res.data[3] ? true : false;
                })
        },
        importSaleList(params) {
            const startOfMonth = this.$moment().startOf('month').format('YYYY-MM-DD');
            const endOfMonth = this.$moment().endOf('month').format('YYYY-MM-DD');
            if (!params) {
                params = this.mergeParams(customProperties);
            }
            const payload = params;
            payload.start_date = startOfMonth;
            payload.end_date = endOfMonth;
            this.$store.dispatch(GET_IMPORT_SALE_EXPECTED_LIST, payload)
                .then((res) => {
                    this.dataSaleMonth = res;
                })
        },

        switchLevel1E(customer_id) {
            Swal.fire({
                title: `Bạn chắc chắn chuyển trạng thái khách hàng sang lịch hẹn level 1E?`,
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Đồng ý',
                showLoaderOnConfirm: true,
                cancelButtonText: 'Hủy',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch(CHANGE_LEVEL_1E, { customer_id })
                        .then((res) => {
                            const customer = this.tableData.find(item => item.id == customer_id);
                            if (customer) {
                                customer.level = "1E<br/>Có lịch hẹn";
                                customer.level_int = 1.991;
                            }

                            this.$notify({
                                title: 'Thành công',
                                message: 'Chuyển trạng thái khách hàng ( có lịch hẹn level 1E ) thành công!',
                                type: 'success'
                            });
                        }).finally(() => {
                        })
                }
            });
        },

        statusAdvice(level, is_advice) {
            if (LEVEL_CONSULTED.includes(level)) {
                return 'Đã tư vấn';
            }

            switch (is_advice) {
                case 2:
                    return 'Khách hàng delay hẹn';
                    break;
                case 3:
                    return 'Khách hàng huỷ hẹn';
                    break;
                default:
                    break;
            }
        },

        handleDropdownCommand(command) {
            if (command === 'import_amount') {
                this.importSalesVisible = true;
            }

            if (command === 'import_customer') {
                this.importCustomerVisible = true;
            }

            if (command === 'export') {
                this.exportListCustomer({ branch_id: this.form.branch_id })
            }

            if (command === 'note') {
                this.$router.push({ name: 'customer-note', params: { id: this.selectedCustomer?.id } });
            }

            if (command === 'searchInfoCustomer') {
                this.dialogSearchInfoCustomerVisible = true;
            }

            if (command === 'notificationSupportEndCourse') {
                this.dialogNotificationSupportEndCourse = true;
            }

            if (command === 'chart') {
                this.$router.push({ name: 'statistical-customer' });
            }
        },

        exportListCustomer(customProperties) {
            const url = this.getExportUrl(customProperties);
            window.open(url, '_blank');
        },

        getExportUrl(customProperties = {}) {
            const params = this.mergeParams(customProperties);
            params.is_export = 1;
            const toQuery = (obj, prefix) => {
                const pairs = [];
                const add = (k, v) => pairs.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);

                Object.keys(obj || {}).forEach((key) => {
                    const value = obj[key];
                    if (value === undefined || value === null || value === '') return; // bỏ trống

                    const k = prefix ? `${prefix}[${key}]` : key;

                    if (Array.isArray(value)) {
                        value.forEach((v) => {
                            if (v !== undefined && v !== null && v !== '') add(`${k}[]`, v);
                        });
                    } else if (typeof value === 'object') {
                        pairs.push(toQuery(value, k));
                    } else {
                        add(k, value);
                    }
                });

                return pairs.filter(Boolean).join('&');
            };

            const queryString = toQuery(params);
            return `${process.env.VUE_APP_API_URL}/customer/export-customer?${queryString}`;
        },

        hasHotKeys(customer) {
            const raw = customer.hot_key;
            if (!raw) return false;
            try {
                const arr = JSON.parse(raw);
                return Array.isArray(arr) && arr.length > 0;
            } catch (e) {
                return false;
            }
        },

        handleHotkey(customer) {
            this.selectHotkey = JSON.parse(customer.hot_key) ?? [];
            this.selectHotkeyDetail = JSON.parse(customer.hot_key_detail) ?? [];
            this.dialogHotKeyDetail = true;
        },

        handleTask(customer) {
            this.selectedCustomer = customer;
            this.dialogTask = true;
        },

        handleCreateTask() {
            this.dialogTask = false;
            this.dialogCreateTask = true;
        },

        updateTypeTaskCustomer(e) {
            this.tableData = this.tableData.map(item => {
                if (item.id === e.customer_id) {
                    return {
                        ...item,
                        status_task: e.status_task,
                    };
                }
                return item;
            });
        },

        changeTypeNewTask(e) {
            this.tableData = this.tableData.map(item => {
                if (item.id === e) {
                    return {
                        ...item,
                        status_task: 2,
                    };
                }
                return item;
            });
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'isPilot', 'isPilotEntrance', 'keyAccount']),
        visibleColumns() {
            const config = [
                { key: 'name', label: 'Họ và tên' },
                { key: 'ngay_sinh', label: 'Năm sinh', style: 'width: 100px' },
                { key: 'phone', label: 'Số điện thoại', style: 'width: 120px' },
                { key: 'object_customer', label: 'Đối tượng', style: 'width: 100px' },
                { key: 'total_input_amount', label: 'Số tiền nhập', style: 'width: 120px' },
                { key: 'co_quan', label: 'Trường học', style: 'width: 100px' },
                { key: 'nguon', label: 'Kênh khách hàng', style: 'width: 130px' },
                { key: 'level', label: 'Level', style: 'min-width: 100px' },
                { key: 'ngay_hen', label: 'Lịch hẹn' },
                { key: 'hot_key', label: 'Phím nóng' },
                { key: 'trang_thai_tu_van', label: 'Trạng thái tư vấn', style: 'width: 150px' },
                { key: 'task', label: 'Task', style: 'width: 150px' },
                { key: 'trung_tam_hen', label: 'Trung tâm hẹn' },
                { key: 'chi_nhanh_hen', label: 'Chi nhánh hẹn' },
                { key: 'tu_van_vien', label: 'Người tư vấn' },
                { key: 'ma_gioi_thieu', label: 'Mã/ người giới thiệu' },
                { key: 'muc_tieu', label: 'Mục tiêu' },
                { key: 'giai_phap_moi_hen', label: 'Giải pháp mời hẹn', style: 'width: 150px' },
                { key: 'thoi_han_cham_soc', label: 'Thời gian chăm sóc', style: 'width: 150px' },
                { key: 'hanh_dong', label: 'Hành động', style: 'width: 180px' },
            ];
            return config.filter(col => this.tableColumnsOption[col.key]);
        },
    }
}
</script>

<style>
#edutalk-customer-list .tree-customer .vue-treeselect__option,
#edutalk-customer-list .vue-treeselect__control,
#edutalk-customer-list input.el-range-input,
#edutalk-customer-list .el-range-editor.el-input__inner,
#edutalk-customer-list input.el-input__inner {
    background: rgb(237 237 237)
}

#edutalk-customer-list .el-select-dropdown__item.hover,
.el-select-dropdown__item {
    background: #ececec;
    color: rgb(61, 61, 61);
    font-family: SVN-Gilroy;
    font-weight: 700;
    line-height: 31px;
    vertical-align: middle;
    letter-spacing: 0px;
}


#edutalk-customer-list .tree-customer .vue-treeselect__control .vue-treeselect__placeholder,
#edutalk-customer-list .tree-customer .vue-treeselect__option,
#edutalk-customer-list .el-input .el-input__inner::placeholder,
#edutalk-customer-list .el-select .el-input__inner::placeholder {
    font-family: SVN-Gilroy;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: rgba(6, 7, 11, 0.6);
}

.el-select-dropdown__item.selected {
    color: #4b6bfd;
}

.text-sales {
    font-family: SVN-Gilroy;
    font-weight: 700;
    font-size: 16px;
    line-height: 31px;
    letter-spacing: 0px;
    vertical-align: middle;
}

#edutalk-customer-list .el-date-editor .el-range__icon,
#edutalk-customer-list .el-date-editor--daterange input::placeholder {
    color: rgb(61, 61, 61);
}

.dialogSetting .el-dialog__body {
    padding: 2px 20px;
}

#edutalk-customer-list .el-date-editor .el-range-separator {
    display: none;
}

.link-im:hover {
    color: rgb(8, 42, 238) !important;
}

#edutalk-customer-list .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 12px 16px;
    z-index: 10;
    margin-left: -70%;
    background: white;
}

.sticky-container {
    max-height: 500px;
    /* điều chỉnh cao sao cho scroll */
    overflow-y: auto;
    position: relative;
    /* để sticky hoạt động */
}

.sticky-header th {
    position: sticky;
    top: 0;
    background: rgb(237 237 237);
    z-index: 10;
    border: rgb(237 237 237) solid 3px;
}
</style>
